/**
 * Підписи полів запиту — дослівно з легасі (`SPEC-022` §8.5, `uk.json`).
 * Одне джерело для ресурсу, картки, канбану й вкладки клієнта.
 */
export const REQUEST_FIELD_LABELS = {
    id: 'Ід',
    title: 'Назва',
    status: 'Статус',
    client: 'Клієнт',
    typesCars: 'Тип авто',
    responsible: 'Відповідальний',
    description: 'Опис',
    loadingCountries: 'Країни завантаження',
    unloadingCountries: 'Країни розвантаження',
    cargo: 'Вантаж',
    files: 'Файли',
    offeredPrice: 'Запропонована ціна',
    offeredPriceCurrency: 'Валюта',
    closingAt: 'Дата закриття',
    lossReason: 'Причина програшу',
    addressLoading: 'Адреса завантаження',
    addressUnloading: 'Адреса розвантаження',
    createdAt: 'Створено',
    createdBy: 'Хто створив',
    updatedAt: 'Дата зміни',
    updatedBy: 'Хто змінив',
} as const
